import Header from "../../components/Header/Header";

const Home = () => {
  return (
    <div className="w-full overflow-x-hidden">
      {/* HEADER */}
      <Header />

      {/* HERO SECTION */}
     

      {/* ABOUT */}
    

      {/* SERVICES */}
     

      {/* DESTINATIONS */}
      

      {/* FOOTER */}
     
    </div>
  );
};

export default Home;
